import { faIgloo, faTachographDigital } from '@fortawesome/free-solid-svg-icons';
import { Controller } from 'stimulus';


class NavMenu extends Controller {

  initialize() {
    this.navHamburger = document.getElementById('menu_hamburger');
  }
  isMobile() {
    return this.navHamburger.offsetWidth > 0;
  }

  toggleMenu(e) {
    e.preventDefault()
    const menuLink = e.currentTarget;
    this.closeMenu(menuLink);
    menuLink.parentElement.classList.toggle('active');
    if (menuLink.parentElement.classList.contains('active')) {
      const submenu = menuLink.nextElementSibling;
      // const icon = this.iconTargets.filter((target) => target.id.includes(targetID))[0];
      if(submenu) {
        submenu.classList.toggle('hidden');
        submenu.classList.toggle('block');
      }
    }
  }
 
  closeMenu(menuItem) {
    const submenus = this.submenuTargets;
    submenus.forEach((submenu) => {
      if (menuItem.parentElement !== submenu.parentElement) {
        submenu.parentElement.classList.remove('active')
      }
      submenu.classList.add('hidden');
      submenu.classList.remove('block');
    })

  }
}

NavMenu.targets = ['submenu', 'icon'];

export default NavMenu;